module.exports = __webpack_public_path__ + "img/spacehbit.ac4456c2.svg";